<template>
      <div>
            <date-picker
					v-model="date"
					:config="options"
					
					@dp-hide="showDatePickResult" class="picker"
					/>
      </div>
</template>
<script>

import datePicker from 'vue-bootstrap-datetimepicker'

import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css'

import '@fortawesome/fontawesome-free/css/all.css'

export default {
	name: 'date',
	data () {
		return {
			date:"",
			options: {
				format: 'YYYY-MM-DD',
				useCurrent: false,
				locale: 'zh-cn',
				tooltips: {
				  selectTime: ''
				},
				
		        
			},
			
			val:'',
			
		}
	},
	
	methods: {
		showDatePickResult: function () {
			// 
			this.val=this.date;
			this.$emit('changeDate',this.val)
        },
        // 获取当前时间，day为number，getDay(-1):昨天的日期;getDay(0):今天的日期;getDay(1):明天的日期;【以此类推】
            getDay(day) {　　
                var today = new Date();　　
                var targetday_milliseconds = today.getTime() + 1000 * 60 * 60 * 24 * day;　　
                today.setTime(targetday_milliseconds); //注意，这行是关键代码
                　　
                var tYear = today.getFullYear();　　
                var tMonth = today.getMonth();　　
                var tDate = today.getDate();　　
                tMonth = this.doHandleMonth(tMonth + 1);　　
                tDate = this.doHandleMonth(tDate);　　
                return ""+tYear  + tMonth + tDate;
            },
            doHandleMonth(month) {　　
                var m = month;　　
                if (month.toString().length == 1) {　　
                    m = "0" + month;　　
                }　　
                return m;
            },
		
	},
	components: {
		datePicker  
	},
	

	created: function () {
		$.extend(true, $.fn.datetimepicker, {
	  		icons: {
	    		time: 'far fa-clock',
	    		date: 'far fa-calendar',
	    		up: 'fas fa-arrow-up',
	    		down: 'fas fa-arrow-down',
	    		previous: 'fas fa-chevron-left',
	    		next: 'fas fa-chevron-right',
	    		today: 'fas fa-calendar-check',
	    		clear: 'far fa-trash-alt',
	    		close: 'far fa-times-circle'
			  },
			  
        })
        this.date=this.getDay(365)
		
	}
}
</script>
<style scoped>
     .picker{
		 font-size: 10px;
		 height:1.5rem;
		 width:5.5rem;
	 }
</style>




// WEBPACK FOOTER //
// src/components/Date/Date4.vue